import { Box, Typography } from "@mui/material";
import { Controller, Control, FieldPath, FieldValues } from "react-hook-form";
import { DropdownMUI } from "../Dropdown";

interface FormDropdownProps<T extends FieldValues> {
  name: FieldPath<T>;
  control: Control<T>;
  items: string[];
  Icon: React.ComponentType<any>;
  placeholder: string;
  required?: boolean;
}

export const FormDropdown = <T extends FieldValues>({
  name,
  control,
  items,
  Icon,
  placeholder,
  required = false,
}: FormDropdownProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Box data-field={name}>
          <DropdownMUI
            onChange={field.onChange}
            items={items}
            Icon={Icon}
            selected={field.value || placeholder}
          />
          {error && (
            <Typography color="error" variant="caption" mt={1}>
              {error.message}
            </Typography>
          )}
        </Box>
      )}
    />
  );
};
